import { CommonModule } from '@angular/common';
import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { FieldWrapper } from '@ngx-formly/core';
import { AccordionModule } from 'primeng/accordion';
import { I18nService } from "../../../../../@core/services/i18n/i18n.service";
import { ModalService } from '../../../../../@core/services/modal/modal.service';
import { PostalAddress } from '../../../../../generated/generated-types';
import { WidgetAddressPostalLinksListComponent } from "../widget-address-postal-links-list/widget-address-postal-links-list.component";
import { WidgetPostalAddressListComponent } from "../widget-postal-address-list/widget-postal-address-list.component";

class menuHolder {
  title: string;
  id: string;
}

@Component({
    selector: 'app-formly-address-panel-wrapper',
    templateUrl: './formly-address-panel-wrapper.component.html',
    imports: [
        CommonModule,
        AccordionModule
    ]
})
export class FormlyAddressPanelWrapperComponent extends FieldWrapper {

  @ViewChild('fieldComponent', { read: ViewContainerRef })
  fieldComponent: ViewContainerRef;

  freeAddressdialogOpen = false;
  documentAddressdialogOpen = false;

  disableAccordion = false;

  constructor(private modalService: ModalService,
    private i18nService: I18nService) {
    super();
  }

  getContextMenuItems() {
    let items: menuHolder[] = [
      {
        id: "choose-free",
        title: "Freie Adresse"
      },
      {
        id: "choose-document-address",
        title: "Dokument Adresse"
      },
    ];

    return items;
  }

  clear() {
    this.disableAndEnableAccordion();
    this.formControl.reset();
    // this.form.get(this.field.name).setValue({});
  }

  contextMenuClick(m: menuHolder) {
    this.disableAndEnableAccordion();

    if (m.id == "choose-free")
      this.openAllPostalAddresses();
    else if (m.id = "choose-document-address") {
      this.openOnlyDocumentPostAddresses();
    }
  }

  openAllPostalAddresses() {
    const ref = this.modalService.fromComponent(WidgetPostalAddressListComponent, {
      size: 'lg',
      verticalAlign: 'top',
      maximizable: true,
      closable: true,
      title: this.i18nService.translate(_("document.choose-free-postal-address")),
      locals: {
        tableSelectionMode: "single",
        noAddNew: true,
        noCopy: true,
        noBaseEdit: true,
      }
    });
    let sub = ref.subscribe(x => {
      if (x)
        this.setPostalAddress(x[0]);
      sub.unsubscribe();
    })
  }

  openOnlyDocumentPostAddresses() {
    const ref = this.modalService.fromComponent(WidgetAddressPostalLinksListComponent, {
      size: 'lg',
      verticalAlign: 'top',
      maximizable: true,
      closable: true,
      title: this.i18nService.translate(_("document.choose-document-postal-address")),
      locals: {
        tableSelectionMode: "single",
        addressId: this.field.parent.model.addressId,
      }
    });
    let sub = ref.subscribe(x => {
      if (x)
        this.setPostalAddress(x[0].postalAddress);
      sub.unsubscribe();
    })
  }

  setPostalAddress(a: PostalAddress) {
    console.log(a);
    this.formControl.reset();
    this.formControl.patchValue(a);

    // this.dialogOpen = false;
    //this.freeAddressDialog?.hide();
  }

  //workaround 
  async disableAndEnableAccordion() {

    this.disableAccordion = true;

    setTimeout(() => {
      this.disableAccordion = false;
    }, 500);

  }

}